var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgRecord = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.001 21C16.9716 21 21.001 16.9706 21.001 12C21.001 7.02943 16.9716 3 12.001 3C7.03042 3 3.00098 7.02944 3.00098 12C3.00098 16.9706 7.03041 21 12.001 21ZM23.001 12C23.001 18.0752 18.0762 23 12.001 23C5.92585 23 1.00098 18.0752 1.00098 12C1.00098 5.92487 5.92585 1 12.001 1C18.0762 1 23.001 5.92487 23.001 12Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "anim",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.21526 12C7.21526 9.35693 9.3579 7.21429 12.001 7.21429C14.6441 7.21429 16.7867 9.35693 16.7867 12C16.7867 14.6431 14.6441 16.7857 12.001 16.7857C9.3579 16.7857 7.21526 14.6431 7.21526 12Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRecord);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Record.8a4a8052f7f4d276bacc4713a9bee0ed.svg";